module.exports = __webpack_public_path__ + "static/media/doorbell.e5ebc927.mp3";